// source: icc.chapters.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.toObject = function(includeInstance, msg) {
  var f, obj = {
contentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
subSectionsList: jspb.Message.toObjectList(msg.getSubSectionsList(),
    proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.toObject, includeInstance),
typeId: jspb.Message.getFieldWithDefault(msg, 4, 0),
documentSlug: jspb.Message.getFieldWithDefault(msg, 5, ""),
chapterSlug: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.deserializeBinaryFromReader);
      msg.addSubSections(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTypeId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentSlug(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setChapterSlug(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.serializeBinaryToWriter
    );
  }
  f = message.getTypeId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getDocumentSlug();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getChapterSlug();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 content_id = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated SubSection sub_sections = 3;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.getSubSectionsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection, 3));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.setSubSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.addSubSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.clearSubSectionsList = function() {
  return this.setSubSectionsList([]);
};


/**
 * optional int32 type_id = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.getTypeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.setTypeId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string document_slug = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.getDocumentSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.setDocumentSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string chapter_slug = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.getChapterSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.prototype.setChapterSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.toObject = function(includeInstance, msg) {
  var f, obj = {
chaptersList: jspb.Message.toObjectList(msg.getChaptersList(),
    proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.deserializeBinaryFromReader);
      msg.addChapters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChaptersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Chapter chapters = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.prototype.getChaptersList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.prototype.setChaptersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.prototype.addChapters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Chapters.prototype.clearChaptersList = function() {
  return this.setChaptersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.toObject = function(includeInstance, msg) {
  var f, obj = {
link: (f = msg.getLink()) && proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.toObject(includeInstance, f),
subSectionsList: jspb.Message.toObjectList(msg.getSubSectionsList(),
    proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.toObject, includeInstance),
contentId: jspb.Message.getFieldWithDefault(msg, 3, 0),
typeid: jspb.Message.getFieldWithDefault(msg, 4, 0),
levelid: jspb.Message.getFieldWithDefault(msg, 5, 0),
parentcontentid: jspb.Message.getFieldWithDefault(msg, 6, 0),
sortorder: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.deserializeBinaryFromReader);
      msg.setLink(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.deserializeBinaryFromReader);
      msg.addSubSections(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTypeid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLevelid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setParentcontentid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSortorder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLink();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.serializeBinaryToWriter
    );
  }
  f = message.getSubSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.serializeBinaryToWriter
    );
  }
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTypeid();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getLevelid();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getParentcontentid();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getSortorder();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional Link link = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.getLink = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.setLink = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.clearLink = function() {
  return this.setLink(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.hasLink = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated SubSection sub_sections = 2;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.getSubSectionsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection, 2));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.setSubSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.addSubSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.clearSubSectionsList = function() {
  return this.setSubSectionsList([]);
};


/**
 * optional int32 content_id = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 typeID = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.getTypeid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.setTypeid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 levelID = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.getLevelid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.setLevelid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 parentContentID = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.getParentcontentid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.setParentcontentid = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 sortorder = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.getSortorder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.SubSection.prototype.setSortorder = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.Link.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy);
